var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,React.createElement("g",{"className":"fill-foreground"},[React.createElement("rect",{"x":"9.4","y":"13.1","width":"3.6","height":"11.5","key":0}),React.createElement("path",{"d":"M22.3,13.1c-1.7,0-2.8,0.4-3.6,1v-1h-3.6v11.5h3.6v-7.2c0,0,0-2.2,2.2-2.2S23,16,23,16v8.6h3.6V16\n\t\t\tC26.6,16,26.6,13.1,22.3,13.1z","key":1}),React.createElement("circle",{"cx":"11.2","cy":"9.2","r":"1.8","key":2})]));
}

Linkedin.defaultProps = {"version":"1.1","width":"36px","height":"36px","viewBox":"0 0 36 36"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
